/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const FriIcon = createIcon({
  displayName: "FriIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M5.23047 12.9995V3.54492H11.0934V4.77291H6.65696V7.65359H10.6733V8.87695H6.65696V12.9995H5.23047Z"
        fill="currentColor"
      />
    </g>
  )
});
